import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { referencesApi } from "./api";
import type { ReferenceEntry, ReferenceInput } from "./types";

export const referenceKeys = {
  all: ["references"] as const,
  publicList: ["references", "public-list"] as const,
};

export function usePublicReferences() {
  return useQuery({ queryKey: referenceKeys.publicList, queryFn: referencesApi.publicList });
}

export function useReferences() {
  return useQuery({ queryKey: referenceKeys.all, queryFn: referencesApi.list });
}

export function useCreateReference() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ input, avatarFile }: { input: ReferenceInput; avatarFile?: File | null }) => referencesApi.create(input, avatarFile),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: referenceKeys.all }),
  });
}

export function useUpdateReference() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ reference, input, avatarFile }: { reference: ReferenceEntry; input: ReferenceInput; avatarFile?: File | null }) =>
      referencesApi.update(reference.id, input, avatarFile),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: referenceKeys.all }),
  });
}

export function useDeleteReference() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: referencesApi.delete,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: referenceKeys.all }),
  });
}
